<template>
  <div class="movie_warp">
    <el-button
      type="primary"
      size="small"
      @click="isShow = true"
      class="taskBtn"
      >新增任务</el-button
    >
    <div class="movide_box">
      <div class="left">
        <h3>上传媒体列表</h3>
        <!--视频分片上传-->
        <uploader
          :options="options"
          :fileStatusText="fileStatusText"
          class="uploader-example"
          ref="uploader"
          @file-added="fileAdd"
          @file-success="onFileSuccess"
        >
          <uploader-unsupport></uploader-unsupport>
          <uploader-list class="upload_list" style="height: 600px">
            <div class="file-panel" slot-scope="props">
              <ul class="file-list">
                <li v-for="file in props.fileList" :key="file.id">
                  <uploader-file
                    :class="'file_' + file.id"
                    ref="files"
                    :file="file"
                    :list="true"
                  ></uploader-file>
                </li>
              </ul>
            </div>
          </uploader-list>
        </uploader>
      </div>
      <div class="right">
        <h3>任务上传列表</h3>
        <div class="right_content">
          <el-table :data="taskList" style="width: 100%" stripe>
            <el-table-column prop="type" label="类型" width="90" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.form && scope.row.form.mediaType === 'video'"
                >
                  视频
                </el-tag>
                <el-tag
                  v-if="
                    scope.row.form && scope.row.form.mediaType === 'video_adv'
                  "
                >
                  视频广告
                </el-tag>
                <el-tag
                  v-if="scope.row.form && scope.row.form.mediaType === 'image'"
                >
                  漫画
                </el-tag>
                <el-tag
                  v-if="scope.row.form && scope.row.form.mediaType === 'text'"
                >
                  小说
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              min-width="180"
              align="center"
            >
              <template slot-scope="scope">
                {{ (scope.row.form && scope.row.form.title) || "未知" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="size"
              label="文件大小"
              width="90"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  (scope.row.files && getSize(scope.row.files.size)) ||
                    (scope.row.form.size && getSize(scope.row.form.size)) ||
                    ""
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag type="info" v-if="scope.row.status == 'wait'"
                  >等待上传</el-tag
                >
                <el-tag
                  type="warning"
                  v-else-if="scope.row.status == 'video_uploaded'"
                  >视频上传中</el-tag
                >
                <el-tag
                  type="warning"
                  v-else-if="scope.row.status == 'video_success'"
                  >视频上传完成</el-tag
                >
                <el-tag
                  type="warning"
                  v-else-if="scope.row.status == 'img_success'"
                  >图集上传完成</el-tag
                >
                <el-tag
                  type="warning"
                  v-else-if="scope.row.status == 'text_success'"
                  >小说上传完成</el-tag
                >
                <el-tag type="success" v-else-if="scope.row.status == 'success'"
                  >上传成功</el-tag
                >
                <el-tag type="error" v-else-if="scope.row.status == 'error'"
                  >上传失败</el-tag
                >
                <el-tag
                  type="error"
                  v-else-if="scope.row.status == 'error_post'"
                  >提交失败</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  @click="deleteTask(scope.$index)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.status == 'error_post'"
                  @click="rest(scope.row, scope.$index)"
                  size="small"
                  >重试</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <addVideo
      v-show="isShow"
      :isShow="isShow"
      @close="isShow = false"
      @addTaskSuccess="addTaskSuccess"
    />
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage.js";
import addVideo from "./addMedia.vue";
import API from "@/api";
import SparkMD5 from "spark-md5";

export default {
  components: {
    addVideo,
  },
  data() {
    return {
      isShow: false,
      trackId: "",
      isUploading: false, //是否正在上传
      fileStatusText: {
        success: "上传成功",
        error: "上传失败",
        uploading: "正在上传",
        paused: "暂停上传",
        waiting: "等待上传",
      },
      attrs: {
        accept: [
          ".mp4",
          ".qlv",
          ".qsv",
          ".ogg",
          ".flv",
          ".avi",
          ".wmv",
          ".rmvb",
        ], //接受文件类型
      },
      taskList: [],
      fileList: [],
    };
  },
  computed: {
    options() {
      return {
        target: baseConfig.baseServerUrl + "/vid/uploadDotStream", //上传地址
        testChunks: false, //是否开启服务器分片校验
        method: "application/json",
        headers: {
          // 额外请求头
          Authorization: local.get("userInfo")
            ? local.get("userInfo").token
            : "",
        },
        fileParameterName: "upload", //文件名参数，默认为file
        query: this.uploadQuery, //额外参数
        singleFile: false, //单文件上传
        chunkSize: 2048000, //分片大小，默认1M
        simultaneousUploads: 6,
        maxChunkRetries: 9, //失败重试次数
        // 把英文时间转成中文
        parseTimeRemaining: function(timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, "年")
            .replace(/\days?/, "天")
            .replace(/\shours?/, "小时")
            .replace(/\sminutes?/, "分钟")
            .replace(/\sseconds?/, "秒");
        },
      };
    },
  },
  methods: {
    deleteTask(index) {
      this.taskList.splice(index, 1);
    },
    async rest(row, index) {
      let from = row.form;
      let res = await API.uploadMedia(from);
      if (res.code === 200) {
        this.taskList[index].status = "success";
        return;
      }
      this.taskList[index].status = "error_post";
    },
    // 获取文件大小
    getSize(byte) {
      let MB = (byte / 1024 / 1024).toFixed(2);
      return MB + "M" || "未知";
    },
    addTaskSuccess(info) {
      let repeatFile = this.taskList.filter((file) => {
        return info.files && info.files.name == file.filename;
      });
      if (repeatFile.length) {
        this.$message({
          type: "error",
          message: "视频名重复,添加失败",
        });
        return;
      }
      info.status = "wait";
      console.log("-------");
      console.log(info);
      console.log("-------");
      if (info.files) {
        info.filename = info.files.name;
        this.$refs.uploader.uploader.addFile(info.files);
        this.taskList.push(info);
      } else if (info.form.text) {
        //小说上传完成
        info.status = "text_success";
        this.taskList.push(info);
        this.uploadPost();
      } else {
        //图集上传完成
        info.status = "img_success";
        this.taskList.push(info);
        this.uploadPost();
      }
      this.$message.success("任务添加成功");
    },
    //视频上传选中时
    fileAdd(file) {
      this.computeMD5(file);
    },
    //定义视频上传唯一标识符id
    generateTaskId() {
      const time = new Date().getTime();
      this.trackId = time;
    },
    computeMD5(file) {
      let fileReader = new FileReader();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();

      //校验MD5 文件先暂停
      file.pause();

      loadNext();
      // 实时展示MD5的计算进度
      this.$nextTick(() => {
        let dom = document.querySelector(
          `.file_${file.id} .uploader-file-status span`
        );
        fileReader.onload = (e) => {
          spark.append(e.target.result);
          if (currentChunk < chunks) {
            currentChunk++;
            loadNext();
            // 实时展示MD5的计算进度
            dom.innerHTML =
              "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%";
          } else {
            let md5 = spark.end();
            this.computeMD5Success(md5, file);
          }
        };
      });
      fileReader.onerror = function() {
        this.$message.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    computeMD5Success(md5, file) {
      file.fileMd5 = md5;
      file.resume();
    },
    // eslint-disable-next-line no-unused-vars
    onFileSuccess(rootFile, file, response, chunk) {
      this.$refs.uploader.uploader.removeFile(file);
      let res = JSON.parse(response);
      let fileName = file.name;
      let fIndex = this.taskList.findIndex(
        (el) => el.files && el.files.name == fileName
      );
      if (res.code === 200) {
        if (fIndex > -1) {
          this.taskList[fIndex].status = "video_success";
          this.taskList[fIndex].form.filename = res.data.filename;
          this.taskList[fIndex].form.size = res.data.size;
          this.taskList[fIndex].form.md5 = res.data.md5;
          this.taskList[fIndex].form.mimeType = res.data.mimeType;
          this.taskList[fIndex].form.sourceID = res.data.sourceID;
          this.taskList[fIndex].form.sourceURL = res.data.sourceURL;
          this.taskList[fIndex].form.resolution = res.data.resolution;
          this.taskList[fIndex].form.playTime = res.data.playTime;
          this.taskList[fIndex].files = null;
        }
        this.uploadPost();
      } else {
        if (fIndex > -1) {
          this.taskList[fIndex].status = "error";
          this.$message.error(`文件${fileName}上传失败`);
        }
      }
    },

    //上传帖子
    async uploadPost() {
      if (this.isUploading) return;
      const result = this.taskList.filter(
        (item) =>
          item.status == "img_success" ||
          item.status == "video_success" ||
          item.status == "text_success"
      );
      if (result.length == 0) {
        this.$message.success("当前任务执行完毕，等待视频上传完成");
        return;
      }
      let taskItem = result[0];
      let form = taskItem.form;
      try {
        this.isUploading = true;
        let res = await API.uploadMedia(form);
        if (res.code === 200) {
          taskItem.status = "success";
          return;
        }
        taskItem.status = "error_post";
      } catch (err) {
        taskItem.status = "error_post";
      } finally {
        this.isUploading = false;
        this.uploadPost();
      }
    },
    //视频上传额外参数
    uploadQuery(file, chunk) {
      return {
        pos: chunk.offset,
        id: file.fileMd5,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.movie_warp {
  h3 {
    padding: 10px 0;
  }

  .movide_box {
    display: flex;
    height: 600px;

    .left {
      flex: 1;
      min-width: 500px;

      .upload_list {
        border: 1px dashed #ccc;
        background-color: #f5f5f5;
        overflow-y: scroll;
      }
    }

    .right {
      margin-left: 20px;
      flex: 1;
      min-width: 500px;

      .right_content {
        border: 1px dashed #ccc;
        height: 100%;
        overflow-y: scroll;

        .right_item {
          height: 30px;
          background: #6aebb4;
        }
      }
    }
  }
}
</style>
